export const needToCheckVersion = [
  'auth/forgot',
  'auth/signup',
  'auth/reset',
  'auth-popup',
  'signup',
  'forgotpassword',
  'art-proofs', //anonymos can access link https://app.mpowerpromo.com/art-proofs/6596bfe64459177fa0c64d8e?token=dSEZAayo7m
  'art-proofs/item',
  'auth/registration',
  'registration',
  'resetpassword',
  'promo-requests', //anonymos can access link https://app.mpowerpromo.com/promo-requests/getProductSellable/SRCG?product_id=DSK368-C&token=1a0098
  'production'
];
